/** Logo Mail — enveloppe deux tons, même esprit que Chat / Agenda. */
export function MailLogoMark({ className = "", title }: { className?: string; title?: string }) {
  return (
    <svg
      className={className}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role={title ? "img" : "presentation"}
      aria-hidden={title ? undefined : true}
    >
      {title ? <title>{title}</title> : null}
      <defs>
        <linearGradient id="mailBootGrad" x1="8" y1="4" x2="40" y2="44" gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor="var(--mail-accent-strong, var(--mail-accent, #2b7fd4))" />
          <stop offset="1" stopColor="color-mix(in srgb, var(--mail-accent, #71baff) 55%, white)" />
        </linearGradient>
      </defs>
      <circle className="mail-boot__disc" cx="24" cy="24" r="24" fill="url(#mailBootGrad)" />
      <rect className="mail-boot__env" x="13.2" y="16.4" width="21.6" height="15.2" rx="2.4" pathLength="1" stroke="#F7F4EE" strokeWidth="1.6" />
      <path className="mail-boot__flap" d="M13.6 17.2 24 25.2 34.4 17.2" pathLength="1" stroke="#F7F4EE" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
      <circle className="mail-boot__seal" cx="32.4" cy="28.6" r="4.3" fill="#F7F4EE" />
      <path className="mail-boot__tick" d="M30.4 28.6 31.8 30.1 34.6 27.2" pathLength="1" stroke="var(--mail-accent-strong, var(--mail-accent, #2b7fd4))" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

type Props = {
  className?: string;
  size?: number | string;
  alt?: string;
};

export function MailLogo({ className = "", size = 72, alt = "Aurélia Mail" }: Props) {
  const dim = typeof size === "number" ? `${size}px` : size;
  return (
    <span
      className={`mail-logo ${className}`.trim()}
      style={{ width: dim, height: dim }}
      role="img"
      aria-label={alt || undefined}
    >
      <MailLogoMark className="mail-logo__svg" title={alt || undefined} />
    </span>
  );
}
